import { colors } from '@cabonline/ui-shared';
import { Check } from '@mui/icons-material';
import { FC, PropsWithChildren, ReactNode, useCallback } from 'react';

import { Text } from '../text';
import {
  CheckboxContainer,
  CheckboxLabelWrap,
  CheckboxText,
  HiddenCheckbox,
  StyledCheckbox,
} from './styles';

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>,
  PropsWithChildren {
  label?: ReactNode;
  testID?: string;
  id: string;
}

export const Checkbox: FC<CheckboxProps> = ({
  children,
  label,
  disabled = false,
  value,
  onChange,
  id,
  testID,
  ...props
}) => {
  const handleToggle = useCallback(() => {
    if (onChange) {
      const event = {
        target: { value },
      } as React.ChangeEvent<HTMLInputElement>;
      onChange(event);
    }
  }, [onChange, value]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter' && !disabled) {
        event.preventDefault();
        handleToggle();
      }
    },
    [handleToggle, disabled]
  );

  return (
    <>
      <CheckboxContainer disabled={disabled}>
        <CheckboxLabelWrap aria-labelledby={`${id}-label`}>
          {!props.readOnly && <HiddenCheckbox
            disabled={disabled}
            type="checkbox"
            onKeyDown={handleKeyDown}
            onChange={onChange}
            value={value}
            data-testid={testID && `${testID}-input`}
            id={id}
            aria-labelledby={`${id}-label`}
            {...props}
          />
          }
          <StyledCheckbox
            checked={!!props.checked}
            data-testid={testID}
          >
            {props.checked && (
              <Check htmlColor={colors.white} fontSize="small" />
            )}
          </StyledCheckbox>
        </CheckboxLabelWrap>
        <CheckboxText
          data-testid={`${testID}-label`}
          onClick={(e) => {
            e.preventDefault();
            if (!disabled) handleToggle();
          }}
        >
          <Text id={`${id}-label`} as="span">{label}</Text>
        </CheckboxText>
      </CheckboxContainer>
      {children}
    </>
  );
};
